import React, { useContext, useEffect, useState } from "react";
import "../../../leaveNotes/leaveNotePopup.css";
import "./DepartmentPopup.css";
import CloseIcon from "../../../../images/CloseIcon.svg";
import AuthContext from "../../../context/auth-context";
import { Fetchdata } from "../../../hooks/getData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpperbarContext from "../../../context/upperbar-context";
import Toast from "../../../Toast";
import $ from "jquery";

export default function DepartmentPopup({
  setDepartmentPopup,
  reload,
  setReload,
  deptList,
  documentFormValue,
  setDocumentFormValue,
  departmentFormError,
  setDepartmentFormError,
  departmentPopup,
}) {
  const { User } = useContext(AuthContext);
  const { mode, appURL } = useContext(UpperbarContext);
  const closePopUp = (e) => {
    setDepartmentPopup(false);
    setDepartmentFormError({});
    $(".addDepartmentPopBg").fadeOut(500);
    $(".addDepartmentPop").slideUp(500);
    setIsSubmit(false);
  };

  useEffect(() => {
    if (departmentPopup) {
      $(".addDepartmentPopBg").fadeIn(500);
      $(".addDepartmentPop").slideDown(500);
    }
  }, [departmentPopup]);

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.type == "checkbox" ? target.checked : target.value;
    setDocumentFormValue({ ...documentFormValue, [name]: value });
  };

  const [isSubmit, setIsSubmit] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = mode === "en" ? "Required" : "आवश्यक छ";
    }
    // if (!values.head) {
    //   errors.head = "Required";
    // }

    return errors;
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setDepartmentFormError(validate(documentFormValue));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(departmentFormError).length === 0 && isSubmit) {
      const dataForm = {
        AuthCode: User.AuthCode,
        ComID: User.ComID,
        UserID: User?.UserID,
        Department: documentFormValue.title,
        // DepHeadID: documentFormValue.head,
        Flag: "i",
        BranchID: User.BranchID,
        FiscalID: User.FiscalID,
        FetchURL: `${appURL}api/olite/admin/department`,
        Type: "POST",
      };
      Fetchdata(dataForm).then(function (result) {
        if (result.StatusCode === 200) {
          setDepartmentPopup(false);
          $(".addDepartmentPopBg").fadeOut(500);
          $(".addDepartmentPop").slideUp(500);
          deptList();
          toast.success(result.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
            theme: "light",
          });
        } else {
          setDepartmentFormError({
            errorv: "Please enter valid credentials",
          });
          toast.error("Error: " + result.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
            theme: "light",
          });
        }
      });

      setIsSubmit(false);
    }
  }, [departmentFormError]);

  //API to get staff list

  const [staffList, setStaffList] = useState([]);

  useEffect(() => {
    staffLst();
  }, []);

  const staffLst = () => {
    const BranchID = "" + User.BranchID;
    const params = {
      AuthCode: User.AuthCode,
      ComID: User.ComID,
      UserID: "-1",
      Flag: "S",
      DFlag: "STAFF",
      BranchID: BranchID,
      Type: "POST",
      FetchURL: `${appURL}api/oliadmin/ref-values`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";
        setStaffList(postResult);
      } else {
        setStaffList([]);
      }
    });
  };

  return (
    <>
      {/* <Toast /> */}
      <div className="container newpopup-bg addDepartmentPopBg">
        <div className="newpopup addDepartmentPop">
          <div className="newpopup-head ps-0 pe-0">
            <div className="popUpTitle">
              {mode === "en" ? "Department" : "विभाग"}
            </div>
            <div className="popUpClose">
              <img
                className="popUpCloseIcon"
                src={CloseIcon}
                alt="CloseIcon"
                onClick={closePopUp}
              />
            </div>
          </div>
          <div className="newpopup-body ps-3 pe-3">
            <div className="form-in-padding">
              <div className="row text-start mt-2 ">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="row text-start ">
                    <div className="form-group mt-0">
                      <label htmlFor="title" style={{ fontSize: "12px" }}>
                        {mode === "en" ? "Title" : "शीर्षक"}
                        <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        id="title"
                        style={{ fontSize: "13px" }}
                        type="text"
                        placeholder={mode === "en" ? "Title" : "शीर्षक"}
                        className="form-control form-control-sm "
                        name="title"
                        value={documentFormValue.title}
                        onChange={handleChange}
                      />
                      {departmentFormError.title && (
                        <p className="errormsg">{departmentFormError.title}</p>
                      )}
                    </div>
                  </div>

                  <div className="row text-start ">
                    <div className="form-group">
                      <label htmlFor="head" style={{ fontSize: "12px" }}>
                        {mode === "en" ? "Select Head" : "प्रमुख चयन गर्नुहोस्"}
                      </label>
                      <select
                        class="form-select form-select-sm"
                        aria-label="Default select example"
                        name="head"
                        value={documentFormValue.head}
                        onChange={handleChange}
                      >
                        <option disabled value="" selected>
                          {mode === "en"
                            ? "Select Head"
                            : "प्रमुख चयन गर्नुहोस्"}
                        </option>
                        <option value="-1">
                          {mode === "en" ? "No Head" : "प्रमुख छैन"}
                        </option>
                        {staffList.map((item) => (
                          <option key={item.UserID} value={item.UserID}>
                            {item.FullName}
                          </option>
                        ))}
                      </select>
                      {/* {departmentFormError.head && (
                      <p className="errormsg">{departmentFormError.head}</p>
                    )} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="new-footer">
            <div className="row  mt-1 mb-1">
              <div>
                <button
                  type="button"
                  class="btn btn-sm me-2"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={formSubmit}
                >
                  {mode === "en" ? "Submit" : "बुझाउनुहोस्"}
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-danger me-3"
                  style={{ color: "white" }}
                  onClick={closePopUp}
                >
                  {mode === "en" ? "Cancel" : "बन्द गर्नुहोस्"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
